module.exports = __webpack_public_path__ + "img/email-header-companyalignment@2x.11135d7c.png";